import { Box, Checkbox, Typography } from '@mui/material';
import React, { useState } from 'react';
import { AutoSizer, List } from 'react-virtualized';
import 'react-virtualized/styles.css'; // Import default styles
import ModalHeader from '../../common/Header';
import MButton from '../../common/MButton';
import DoDisturbOnIcon from '@mui/icons-material/DoDisturbOn';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
const SelectItemForSMS = (props) => {
    const { handleBack, filterValue, setFilterValue, setCurrentScreen } = props;
    const [openStates, setOpenStates] = useState({}); // To manage row expansion states
    const handleCheckboxChange = (BookingID) => {
        setFilterValue((prev) => {
            const prevSelected = prev.selectedItemsForSMS || []; // Ensure it's always an array

            return {
                ...prev,
                selectedItemsForSMS: prevSelected.includes(BookingID)
                    ? prevSelected.filter(id => id !== BookingID) // Remove if exists
                    : [...prevSelected, BookingID], // Add if not exists
            };
        });
    };




    const toggleOpen = (index) => {
        setOpenStates((prev) => ({ ...prev, [index]: !prev[index] }));
    };
    const detailsList = [
        { name: 'Seats', field: 'SeatNos' },
        { name: 'Agent/Branch', field: 'BookedBy' },
        { name: 'Booking Type', field: 'BookingType' },
        { name: 'Ticket No', field: 'TicketNo' },
        { name: 'Passenger Name', field: 'PassengerName' },
        { name: 'Contact No', field: 'PassengerContactNo1' },
        { name: 'Service Name', field: 'ServiceName' },
    ]
    const rowRenderer = ({ index, key, style }) => {
        const obj = filterValue?.serviceData[index];
        const isOpen = openStates[index];

        return (
            <Box className="reportCard" >
                <Box className="cardHeader">
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography sx={{ flex: 0.8, color: '#ff7100!important' }}>{obj?.BookingID}</Typography>
                        <Typography sx={{ flex: 1, textAlign: 'right' }}>{obj.PickupName}</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography sx={{ flex: 0.8 }}>{obj?.CityName}</Typography>
                        <ArrowRightAltIcon />
                        <Typography sx={{ flex: 1, textAlign: 'right' }}>{obj.CityName1}</Typography>
                        <Checkbox
                            color="red"
                            size="small"
                            checked={filterValue?.selectedItemsForSMS?.includes(obj?.BookingID)}
                            onChange={() => handleCheckboxChange(obj?.BookingID)}
                        />

                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', }}>
                        <Typography>{`Seats ${obj?.Seatcount}`}</Typography>
                        <Typography>₹ {obj?.TotalFare}</Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => toggleOpen(index)}>
                            {isOpen ? (
                                <>
                                    <DoDisturbOnIcon />
                                    <Typography sx={{ color: '#0086FF', marginLeft: 0.5 }}>Less</Typography>
                                </>
                            ) : (
                                <>
                                    <AddCircleOutlineIcon />
                                    <Typography sx={{ color: '#0086FF', marginLeft: 0.5 }}>More</Typography>
                                </>
                            )}
                        </Box>
                    </Box>

                </Box>
                {isOpen && (
                    <Box className='reportDetails'>
                        {detailsList.map((val) => (
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', paddingY: '4px' }}>
                                <Typography sx={{ flex: 1 }}>{val.name}</Typography>
                                <Typography sx={{ flex: 0.1 }}>:</Typography>
                                <Typography sx={{ flex: 1 }}>{obj[val.field]} </Typography>
                            </Box>
                        ))}
                    </Box>
                )}
            </Box>
        );
    };
    const handleProceedClick = () => {
        setFilterValue((prev) => ({
            ...prev,
            smsType: []
        }));
        setCurrentScreen(5)
    };

    return (
        <Box>
            <ModalHeader headerText="Select Items For SMS" showBackArrow={true} onBackClick={handleBack} />
            <Box className="trip-list" sx={{ width: '100%', height: 'calc(100vh - 40px)' }}>
                <AutoSizer>
                    {({ height, width }) => (
                        <List
                            width={width}
                            height={height}
                            rowCount={filterValue?.serviceData?.length || 0}
                            rowHeight={400} // Adjust the height based on your design
                            rowRenderer={rowRenderer}
                        />
                    )}
                </AutoSizer>
            </Box>
            {filterValue?.selectedItemsForSMS?.length > 0 && (
                <Box className="bookingTypeBottom">
                    <MButton btnName="Proceed" className="btnContinue" onClick={handleProceedClick} />
                </Box>
            )}
        </Box>
    );
};

export default SelectItemForSMS;
